import {
    CREATE_ACCESSORIES_PO_INWARD_MASTER_REQUEST,
    CREATE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS,
    CREATE_ACCESSORIES_PO_INWARD_MASTER_FAILURE,
    DELETE_ACCESSORIES_PO_INWARD_MASTER_REQUEST,
    DELETE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS,
    DELETE_ACCESSORIES_PO_INWARD_MASTER_FAILURE,
    FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_REQUEST,
    FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS,
    FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_FAILURE,
    FETCH_ACCESSORIES_PO_INWARD_MASTER_REQUEST,
    FETCH_ACCESSORIES_PO_INWARD_MASTER_SUCCESS,
    FETCH_ACCESSORIES_PO_INWARD_MASTER_FAILURE,
    UPDATE_ACCESSORIES_PO_INWARD_MASTER_REQUEST,
    UPDATE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS,
    UPDATE_ACCESSORIES_PO_INWARD_MASTER_FAILURE,
    RESET_ACCESSORIES_PO_INWARD_MASTER_INFO,
    CREATE_ACCESSORIES_PO_INWARD_MASTER_FORM,
    UPDATE_ACCESSORIES_PO_INWARD_MASTER_FORM,
    NAVIGATE_ACCESSORIES_PO_INWARD_DETAILS,
    NAVIGATE_ACCESSORIES_PO_INWARD_MASTER,
    FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_FAILURE,
    FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_SUCCESS,
    SET_UNIT_NAME_ACCESSORIES_INWARD,
    ACCESSORIES_PO_INWARD_USERFORM_RESET,
    SET_ACTIVE_KEY_ACCESSORIES_PO_INWARD_MASTER,
    SET_PENDING_GRID_NAME_ACCESSORIES_PO_INWARD,
    RESET_FORM_DATA_WITHOUT_INWARD_ID,
    SET_END_DATE_ACCESSORIES_INWARD,
    SET_START_DATE_ACCESSORIES_INWARD
} from './accessoriesPoInwardHeader.actionsType';

export const ACCESSORIES_PO_INWARD_MASTER = 'accessoriesPoInwardHeader';

let initialState = {
    loading: false,
    accessoriesPoInwardHeader: [],
    pendingAccessoriesPO: [],
    accessoriesPoInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: 0,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: 0
    },
    selectedState: {},
    renderGridBtn: 'pendingGrid',
    errorMessage: '',
    accessoriesInwardId: '',
    activeKey: 1,
    singleAccessoriesPoInwardData: null,
    isAccessoriesPoInwardDetails: false,
    unitId: 1,
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
};

export let accessoriesPoInwardHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ACCESSORIES_PO_INWARD_MASTER_REQUEST:
        case FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_REQUEST:
        case CREATE_ACCESSORIES_PO_INWARD_MASTER_REQUEST:           
        case UPDATE_ACCESSORIES_PO_INWARD_MASTER_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_REQUEST:
        case DELETE_ACCESSORIES_PO_INWARD_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPoInwardHeader: updatePayload
            };
        case FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingAccessoriesPO: updatePayload
            };
        case CREATE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                },
                accessoriesInwardId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case UPDATE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPoInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_ACCESSORIES_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case RESET_ACCESSORIES_PO_INWARD_MASTER_INFO:
            return {
                ...state,
                accessoriesPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                }
            };
        case CREATE_ACCESSORIES_PO_INWARD_MASTER_FORM:
        case UPDATE_ACCESSORIES_PO_INWARD_MASTER_FORM:
            return {
                ...state,
                loading: false,
                accessoriesPoInwardHeaderForm: {
                    ...state.accessoriesPoInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case ACCESSORIES_PO_INWARD_USERFORM_RESET:
            return {
                ...state,
                accessoriesPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                },
                accessoriesInwardId: [],
                selectedState: {},
                activeKey: 1
            };
        case FETCH_ACCESSORIES_PO_INWARD_MASTER_FAILURE:
        case FETCH_PENDING_ACCESSORIES_PO_IN_INWARD_FAILURE:
        case CREATE_ACCESSORIES_PO_INWARD_MASTER_FAILURE:
        case UPDATE_ACCESSORIES_PO_INWARD_MASTER_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_PO_INWARD_MASTER_FAILURE:
        case DELETE_ACCESSORIES_PO_INWARD_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_ACCESSORIES_PO_INWARD_DETAILS:
            return {
                ...state,
                isAccessoriesPoInwardDetails: true,
                singleAccessoriesPoInwardData: updatePayload.singleAccessoriesPoInwardData
            };
        case NAVIGATE_ACCESSORIES_PO_INWARD_MASTER:
            return {
                ...state,
                isAccessoriesPoInwardDetails: false
            };
        case SET_PENDING_GRID_NAME_ACCESSORIES_PO_INWARD:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_ACCESSORIES_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_ACCESSORIES_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_ACCESSORIES_INWARD:
            return {
                ...state,
                endDate: payload
            };
        case SET_ACTIVE_KEY_ACCESSORIES_PO_INWARD_MASTER:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case RESET_FORM_DATA_WITHOUT_INWARD_ID:
            return {
                ...state,
                accessoriesPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: 0,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: 0
                },
                selectedState: {}
            };
        default:
            return state;
    }
};
